var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"justgage"},[_c('vue-justgage',{ref:"g1",staticClass:"gauge",attrs:{"id":"g1","data-value":"100"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }